import WebZoneLanding from "./Pages/WebZoneLanding";
export default function App() {
  return <WebZoneLanding />;
}
